import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import Company from "@/model/company";

@Module({ namespaced: true })
export default class CompanyModule extends VuexModule {
  public mcCompany: Company = null;
  public mcCompanyId: string = null;
  public companiesCooperate: [] = null;
  @Mutation
  set(company: Company): void {
    this.mcCompany = company;
  }

  @Mutation
  upMcCompanyId(id: string): void {
    this.mcCompanyId = id;
  }

  @Mutation
  upCompaniesCooperate(companiesCooperate: []): void {
    this.companiesCooperate = companiesCooperate;
  }
  @Mutation
  deleteCooperate(index: number): void {
    this.mcCompany.companies_cooperate.splice(index, 1);

  }

  @Action({ rawError: true })
  setCompany(company: Company) {
    this.context.commit("set", company);
  }
  @Action({ rawError: true })
  clear() {
    this.context.commit("set", null);
  }

  @Action({ rawError: true })
  setCompaniesCooperate(companiesCooperate: []) {
    this.context.commit("upCompaniesCooperate", companiesCooperate);
  }

  @Action({ rawError: true })
  setMcCompanyId(id: string): void {
    this.context.commit("upMcCompanyId", id);
  }

  @Action({ rawError: true })
  spliceCooperate(index: number): void {
    this.context.commit("deleteCooperate", index);
  }

  get getMcCompany(): Company {
    return this.mcCompany;
  }
}